import { ComponentType, FC } from 'react';

import IconButton from '@mui/material/IconButton';

import colors from '@/styles/themes/colors';

import styles from './SocialButton.module.scss';

interface SocialButtonProps {
  name: string;
  href: string;
  icon: ComponentType<{ fill?: string; secondaryFill?: string }>;
}

const SocialButton: FC<SocialButtonProps> = ({ name, href, icon: Icon }) => (
  <IconButton
    component="a"
    href={href}
    target="_blank"
    rel="nofollow noopener noreferrer"
    aria-label={name}
    classes={{ root: styles.root }}
    className={styles.container}
  >
    <Icon fill={colors.graytone400} secondaryFill={colors.graytone400} />
  </IconButton>
);

export default SocialButton;
